import React from "react";
import { useForm, FormProvider, FieldValues } from "react-hook-form";
import { FormProps } from "./types";

const Form = <T extends FieldValues,>(props: FormProps<T>) => {
    const { defaultValues, children, onSubmit, cssName } = props;
    //onChange | onBlur | onSubmit | onTouched | all = 'onSubmit'
    //https://react-hook-form.com/api/useform
    const methods = useForm<T>({ defaultValues, mode: "onChange" });

    // React.useEffect(() => {
    //     if (!methods.formState.isDirty) {
    //         return;
    //     }
    // }, [methods.formState.isDirty]);

    return (
        <FormProvider {...methods}>
            <form className={cssName} onSubmit={methods.handleSubmit(onSubmit)}>
                {children}
            </form>
        </FormProvider>
    );
}

export default Form;